import scss from "./Table.module.scss"

const Table = ({ children, maxHeight }) => {
    return (
        <div className={scss.tableScroll} style={maxHeight ? { maxHeight } : undefined}>
            <table className={scss.table}>
                {children}
            </table>
        </div>
    )
}

export default Table
